import { createFileRoute } from '@tanstack/react-router';

import { ChecksPage } from '@/features/logbook';

export const Route = createFileRoute('/logbook/checks')({
  component: ChecksPage,
});
